import { useContext } from 'react'
import { USER_CONTEXT } from '../context/ContextProvider'
import { useUser } from '@clerk/clerk-react'
import { useParams } from 'react-router-dom'

const useCreateTaskObject = () => {
  let { id } = useParams()
  let { data } = useContext(USER_CONTEXT)
  let { user } = useUser()
  let status = ['Backlog', 'To do', 'In Progress', 'Completed']

  let createObject = (form, group, category, description, edit = false) => {
    let date = new Date()
    let oldValue = {}
    if (edit) {
      oldValue = data.tasks.find((task) => task.id == id)
    }
    return {
      id: edit ? id : date.getTime(),
      title: form.current.title.value,
      tagline: form.current.tagline.value,
      tags: form.current.tags.value,
      status: status[category],
      group: data.groups[group],
      description,
      ...(!edit
        ? {
            creator: {
              id: user.id,
              name: user.fullName,
              avatar: user.profileImageUrl,
              email: user.emailAddresses[0].emailAddress,
            },
            createdAt: `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`,
          }
        : {
            creator: oldValue.creator,
            createdAt: oldValue.createdAt,
          }),
    }
  }

  return createObject
}
export default useCreateTaskObject
